// LOAD USER APPS
export const loadUserApps = (payload) => ({
    type: 'OLY_LOAD_USER_APPS',
    payload,
});
export const loadUserAppsSuccess = (loadUserApps) => ({
    type: 'OLY_LOAD_USER_APPS_SUCCESS',
    payload: { loadUserApps },
});
export const loadUserAppsError = (error) => ({
    type: 'OLY_LOAD_USER_APPS_ERROR',
    payload: { error },
});
// PULL USER APPS
export const pullUserApps = (payload) => ({
    type: 'OLY_PULL_USER_APPS',
    payload,
});
export const pullUserAppsSuccess = () => ({
    type: 'OLY_PULL_USER_APPS_SUCCESS',
});
export const pullUserAppsError = (error) => ({
    type: 'OLY_PULL_USER_APPS_ERROR',
    payload: { error },
});
// DELETE USER APP
export const deleteUserApp = (payload) => ({
    type: 'OLY_DELETE_USER_APP',
    payload,
});
export const deleteUserAppSuccess = (deletedAppName) => ({
    type: 'OLY_DELETE_USER_APP_SUCCESS',
    payload: { deletedAppName },
});
export const deleteUserAppError = (error) => ({
    type: 'OLY_DELETE_USER_APP_ERROR',
    payload: { error },
});
// USER APP RESET
export const userAppsReset = () => ({
    type: 'OLY_USER_APP_RESET',
});
export default {
    loadUserApps,
    loadUserAppsSuccess,
    loadUserAppsError,
    pullUserApps,
    pullUserAppsSuccess,
    pullUserAppsError,
    deleteUserApp,
    deleteUserAppSuccess,
    deleteUserAppError,
    userAppsReset,
};
